// ============================================================
// GLIGHTBOX (Galeria realizacji)
// ============================================================

import GLightbox from 'glightbox';

export function initLightbox() {
    GLightbox({
        selector:            '.gallery-item',
        touchNavigation:     true,
        loop:                true,
        autoplayVideos:      true,
        zoomable:            true,
        draggable:           true,
        closeButton:         true,
        closeOnOutsideClick: true,
        skin:                'clean',
        moreText:            'Zobacz więcej',
        moreLength:          60,
    });
}
